<mat-dialog-actions>
  <button *ngIf="buttons.secondary"
          size="small"
          mat-raised-button
          [mat-dialog-close]="buttons.secondary.choice">
    {{ buttons.secondary.labelKey | translate }}
  </button>

  <button *ngIf="buttons.primary"
          mat-raised-button
          color="primary"
          size="small"
          [mat-dialog-close]="buttons.primary.choice">
    {{ buttons.primary.labelKey | translate }}
  </button>
</mat-dialog-actions>



// WEBPACK FOOTER //
// ./src/app/dialogs/dialog-buttons.component.html